'use client';
import React, { ReactNode, useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';

import { useAnalytics } from '../../useAnalytics';
import { useSegmentPageView } from '../segment-page-view';

export interface SegmentEventViewedProps {
  className?: string;
  children: ReactNode;
  eventName: string;
  eventPayload?: Record<string, string | number | boolean>;
}

export const SegmentEventViewed: React.FC<SegmentEventViewedProps> = ({
  className,
  children,
  eventName,
  eventPayload,
}) => {
  const { segmentTrack } = useAnalytics();
  const { pageViewReady } = useSegmentPageView();
  const [viewed, setViewed] = useState(false);

  useEffect(() => {
    if (pageViewReady && viewed) {
      segmentTrack(eventName, eventPayload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageViewReady, viewed]);

  return (
    <InView
      className={className}
      onChange={(inView) => {
        setViewed(inView);
      }}
      triggerOnce
    >
      {children}
    </InView>
  );
};
